module.exports = __webpack_public_path__ + "img/rdsc_icon_right.918be99e.png";